const MAX_EDGE = 1600;
const JPEG_QUALITY = 0.75;

const loadImage = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load image: ${url}`));
    img.src = url;
  });

const downscaleOne = async (url: string): Promise<string> => {
  const img = await loadImage(url);
  const {naturalWidth: w, naturalHeight: h} = img;
  const scale = Math.min(1, MAX_EDGE / Math.max(w, h));
  const targetW = Math.round(w * scale);
  const targetH = Math.round(h * scale);
  const canvas = document.createElement('canvas');
  canvas.width = targetW;
  canvas.height = targetH;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas 2D context unavailable');
  ctx.drawImage(img, 0, 0, targetW, targetH);
  return canvas.toDataURL('image/jpeg', JPEG_QUALITY);
};

export const downscaleImages = async (
  urlsByKey: Record<string, string>,
): Promise<Record<string, string>> => {
  const entries = Object.entries(urlsByKey);
  const results = await Promise.all(
    entries.map(async ([key, url]) => {
      try {
        return [key, await downscaleOne(url)] as const;
      } catch {
        return [key, url] as const;
      }
    }),
  );
  return Object.fromEntries(results);
};
